module.exports = __webpack_public_path__ + "static/media/ZEC-BNB.523700f7.svg";